// Fixed navbar height (h-16 mobile / h-20 desktop) plus a little breathing room.
export const HEADER_OFFSET = 96;

/**
 * Smoothly scrolls to an in-page section by id, accounting for the fixed header.
 * Returns true if the target element was found on the current page.
 */
export function scrollToSection(id: string): boolean {
  const el = document.getElementById(id);
  if (!el) return false;
  const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
  window.scrollTo({ top, behavior: "smooth" });
  return true;
}
